import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Input, Row, Select, Tag, Typography } from "antd";
import { Icon } from "assets/icons";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import { PRODUCT_INPUT_TYPE } from "config/constants";
import {
  FilterLevelPrice,
  FilterManufacture,
} from "features/Campaign/components/Detail/ProductPromo/components/FilterProduct";
import RadioGroup from "features/Warranty/WarrantyList/component/RadioGroup";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { formatCurrency } from "utils/helperFuncs";
import TagsList from "../../../OneOnProductForm/TagsList";

import { Form } from "antd";
import { Option } from "antd/lib/mentions";
import CustomTextHiddenLine from "components/CustomTextHiddenLine";
import { SEARCH_TYPE, SELLING_STATUS } from "pages/App/Product/constants";
import {
  FilterInstockVat,
  FilterStatus,
  FilterVatPercent,
} from "pages/App/Product/Product/List/components/FilterProduct";
import React from "react";
import CategoryTreeFilter from "../../../OneOnProductForm/CategoryTreeFilter";
import "../../../OneOnProductForm/ModalSelectProduct/index.scss";
import { useProductPickerModal } from "./useProductPickerModal";

export const ProductPickerModal = ({ visible, onCancel, onOk, title, initialSelectedProducts = [], modalType }) => {
  const [form] = Form.useForm();
  const prevModalTypeRef = React.useRef(modalType);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);

  const {
    filterItemsTypeOptions,
    rowSelection,
    loadingProduct,
    isFilterSelected,
    setIsFilterSelected,
    selectedRows,
    productData,
    paginationData,
    dataDuplicateCode,
    prodAtt,
    warehouses,
    handleSelectProduct,
    filterProductByCategoryId,
    handleSearch,
    handleChange,
    onTableChange,
    renderProductAttributes,
    renderChildrenInStock,
    params,
    dataManufactures,
    loadingManufactures,
    listWarehouse,
    loadingWarehouses,
    setParams,
    filterProductExtra,
    filterProductPrices,
    searchType,
    itemsSearchBulk,
    handleChangeSelectSearch,
    handleSelectSearchType,
    resetSelection,
  } = useProductPickerModal({
    form,
    isUpdate: false,
    dataProductsServer: [],
    handleGetDataSource: (products) => {
      onOk?.(products);
    },
    dataSourceSelected: initialSelectedProducts,
    idDeleted: [],
  });

  // Reset data khi modalType thay đổi
  React.useEffect(() => {
    if (visible && prevModalTypeRef.current !== modalType && prevModalTypeRef.current !== undefined) {
      // Reset selectedRows và selectedRowKeys khi modalType thay đổi
      resetSelection();
    }
    prevModalTypeRef.current = modalType;
  }, [visible, modalType]);

  // Set default tab là "Đã chọn" khi mở modal và đã có sản phẩm được chọn trước đó
  React.useEffect(() => {
    if (visible && initialSelectedProducts?.length > 0) {
      setIsFilterSelected(true);
    }
  }, [visible, initialSelectedProducts?.length, setIsFilterSelected]);

  const handleSave = () => {
    handleSelectProduct();
  };

  const columns = [
    {
      title: "THÔNG TIN SẢN PHẨM",
      dataIndex: "code",
      width: 250,
      fixed: "left",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Link target={"_blank"} to={`/product/detail/${record?.id}`} className="linked-text">
              <Typography.Link strong>{record?.code}</Typography.Link>
            </Link>
            <CustomTextHiddenLine text={record?.name} line={2} />
          </div>
        );
      },
    },
    {
      title: t("product.tableTitle.brand"),
      dataIndex: ["manufacturer", "name"],
      align: "center",
      render: (_, record) => <div>{record?.manufacturer?.name ? record.manufacturer.name : "- -"}</div>,
      filterDropdown: <FilterManufacture dataManufactures={dataManufactures} onFilter={filterProductExtra} />,
    },
    {
      title: t("product.tableTitle.warranty"),
      dataIndex: "warranty",
      align: "center",
      render: (_, record) => <div>{record?.warranty ? `${record.warranty} ${t("common.month")}` : "- -"}</div>,
    },
    ...renderProductAttributes(prodAtt),
    {
      title: "LOẠI % VAT",
      dataIndex: "vatPercent",
      align: "center",
      render: (_, record) => {
        return <div>{record.vatPercent >= 0 ? `${record.vatPercent}%` : "KCT"}</div>;
      },
      width: 150,
      editable: "true",
      inputType: PRODUCT_INPUT_TYPE.VAT_PERCENT,
      filterDropdown: <FilterVatPercent onFilter={filterProductExtra} defaultValue={params.filters.vatPercent} />,
    },
    {
      title: "GIÁ CÓ VAT",
      dataIndex: ["productPrices", "priceVat"],
      align: "right",
      render: (_, record) => {
        return (
          <div>
            {record?.productPrices?.priceVat ? formatCurrency(record?.productPrices?.priceVat) : formatCurrency(0)}
          </div>
        );
      },
      editable: "true",
      inputType: PRODUCT_INPUT_TYPE.CURRENCY,
      filterDropdown: (
        <FilterLevelPrice
          onFilter={(priceLevel) => {
            filterProductPrices(priceLevel, "priceVat");
          }}
          defaultValue={params.filters.priceVat}
        />
      ),
    },
    {
      title: <span>{t("product.tableTitle.inStockVat")}</span>,
      align: "center",
      render: (_, record) => {
        return (record?.stocks && record?.stocks[0].quantityRealStockHasVat) ?? 0;
      },
      width: 150,
      filterDropdown: <FilterInstockVat onFilter={filterProductExtra} defaultValue={params.filters.realStockHasVat} />,
    },
    {
      title: t("product.tableTitle.inStock"),
      children: renderChildrenInStock(warehouses),
      align: "center",
    },
    {
      title: t("product.tableTitle.inStock"),
      align: "right",
      render: (_, record) => <div>{record?.stocks?.at(0).quantity || "- -"}</div>,
    },
    {
      title: t("product.tableTitle.status"),
      dataIndex: "isActive",
      align: "center",
      editable: "false",
      fixed: "right",
      filterDropdown: <FilterStatus onFilter={filterProductExtra} defaultValue={params?.filters?.sellingStatuses} />,
      render: (_, record) => {
        return (
          <div>
            {record?.sellingStatus === SELLING_STATUS.AVAILABLE && (
              <Tag className="custom-tag-status-product-available">Đang kinh doanh</Tag>
            )}
            {record?.sellingStatus === SELLING_STATUS.UNAVAILABLE && (
              <Tag className="custom-tag-status-product-unavailable">Ngừng kinh doanh</Tag>
            )}
            {record?.sellingStatus === SELLING_STATUS.CONTACT && (
              <Tag className="custom-tag-status-product-contact">Liên hệ</Tag>
            )}
          </div>
        );
      },
    },
  ];

  // Reset currentPage khi chuyển tab
  React.useEffect(() => {
    setCurrentPage(1);
  }, [isFilterSelected]);

  // Handler cho pagination
  const handleTableChange = (pagination, filters, sorter) => {
    if (isFilterSelected) {
      // Tab "Đã chọn" - chỉ update currentPage và pageSize (FE pagination)
      setCurrentPage(pagination.current);
      if (pagination.pageSize !== pageSize) {
        setPageSize(pagination.pageSize);
        setCurrentPage(1); // Reset về trang 1 khi thay đổi pageSize
      }
    } else {
      // Tab "Tất cả" - gọi API (BE pagination)
      if (pagination.pageSize !== pageSize) {
        setPageSize(pagination.pageSize);
      }
      onTableChange(pagination, filters, sorter);
    }
  };

  // Data source cho table - với pagination FE cho tab "Đã chọn"
  const getDataSource = () => {
    if (isFilterSelected) {
      // Tab "Đã chọn" - pagination FE
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      return (selectedRows || []).slice(startIndex, endIndex);
    } else {
      // Tab "Tất cả" - data từ API
      return productData || [];
    }
  };

  const dataSource = getDataSource();

  return (
    <div className="custom-modal-select-product">
      <CustomModal
        {...{
          message: <Typography.Title level={3}>{title || t("campaign.combo.addProductToPromotion")}</Typography.Title>,
          footer: false,
          width: "90%",
          visible: visible,
          onCancel: () => {
            onCancel?.();
          },
          onOke: handleSave,
          buttonLoading: false,
          okeButtonLabel: t("campaign.combo.addProduct"),
          children: (
            <>
              <Row
                gutter={[16, 4]}
                style={{
                  alignItems: "center",
                  borderRadius: "8px",
                  margin: 0,
                }}
              >
                <Col span={24}>
                  <Row gutter={[16]} style={{ alignItems: "flex-end" }}>
                    <Col span={6}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography.Text style={{ marginBottom: "4px" }} strong>
                          {t("product.productForm.category")}
                        </Typography.Text>
                        <div>
                          <CategoryTreeFilter
                            onFilter={filterProductByCategoryId}
                            defaultValue={params.filters.categoryIDs}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col span={10}>
                      <div style={{ height: "32px", display: "flex", alignItems: "center" }}>
                        <Typography.Text strong>{t("campaign.combo.searchAdvance")}</Typography.Text>
                      </div>
                      <div className="custom-search-product-wrapper">
                        <Input.Group compact>
                          <Select
                            onChange={handleSelectSearchType}
                            defaultValue={searchType}
                            value={searchType}
                            className="select-search-type"
                          >
                            <Option value={SEARCH_TYPE.SINGLE}>Tìm kiếm từng mã sản phẩm</Option>
                            <Option value={SEARCH_TYPE.BULK}>Tìm kiếm hàng loạt</Option>
                          </Select>
                          {searchType === SEARCH_TYPE.SINGLE ? (
                            <Input
                              prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                              placeholder={t("product.searchPlaceholder")}
                              onChange={handleSearch}
                              allowClear={true}
                              defaultValue={params.filters.query}
                              style={{ width: "350px" }}
                            />
                          ) : (
                            <Select
                              mode="tags"
                              value={itemsSearchBulk}
                              onChange={handleChangeSelectSearch}
                              placeholder="Tìm kiếm các mã sản phẩm được ngăn cách với nhau bằng dấu phẩy/ đấu cách"
                              className="custom-select-search-product"
                              open={false}
                              dropdownStyle={{ display: "none" }}
                            />
                          )}
                        </Input.Group>
                      </div>
                    </Col>
                    <Col span={8} style={{ paddingTop: "30px" }}>
                      <RadioGroup
                        filterItemsTypeOptions={filterItemsTypeOptions}
                        handleChange={handleChange}
                        isUpdate={false}
                        value={isFilterSelected}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TagsList
                    listFilter={params.filters}
                    dataManufactures={dataManufactures}
                    loadingManufactures={loadingManufactures}
                    dataWarehouses={listWarehouse}
                    loadingWarehouses={loadingWarehouses}
                    dataAttributes={prodAtt}
                    params={params}
                    setParams={setParams}
                  />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <CustomTable
                    rowSelection={{
                      type: "checkbox",
                      ...rowSelection,
                    }}
                    columns={columns}
                    loading={loadingProduct}
                    dataSource={dataSource ?? dataSource}
                    rowKey={(record) => record?.id}
                    onChange={handleTableChange}
                    pagination={{
                      total: isFilterSelected ? selectedRows?.length : paginationData?.total,
                      pageSize: isFilterSelected ? pageSize : paginationData?.limit,
                      current: isFilterSelected ? currentPage : paginationData?.offset / paginationData?.limit + 1 || 1,
                      showSizeChanger: true,
                      pageSizeOptions: ["5", "10", "20", "50", "100"],
                    }}
                    scroll={{ x: "max-content" }}
                  />
                </Col>
                <Col span={24}>
                  {dataDuplicateCode?.length ? (
                    <Typography>
                      <Typography.Paragraph type="danger">
                        {t("campaign.combo.errorDuplicateCodes", {
                          productLength: dataDuplicateCode?.length,
                        })}
                        :{" "}
                        <Typography.Text type="danger" strong>
                          {dataDuplicateCode?.map((item) => item).join(`, `)}
                        </Typography.Text>
                      </Typography.Paragraph>
                      <Typography.Paragraph type="danger">
                        {t("campaign.combo.errorDuplicateCodesWarning")}
                      </Typography.Paragraph>
                    </Typography>
                  ) : null}
                </Col>
              </Row>
            </>
          ),
        }}
      />
    </div>
  );
};
